import React, { useEffect, useRef, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import VisitsService from "../../services/VisitsService";
import Invoice from "./EmployerDashboardComponent/Invoice";
import Physical from "./EmployerDashboardComponent/Physical";
import DrugScreen from "./EmployerDashboardComponent/DrugScreen";
import Lab from "./EmployerDashboardComponent/Lab";
import MissingClaim from "./EmployerDashboardComponent/MissingClaim";
import WorkRestrictions from "./EmployerDashboardComponent/WorkRestrictions";
import DropDownService from "../../services/DropDownService";
import FormInputs from "../../components/UI/FormInputs";
import withReduxState from "../../hoc/wReduxState";
import Vaccines from "./EmployerDashboardComponent/Vaccines";
import ComplianceMonitor from "./EmployerDashboardComponent/ComplianceMonitor";
import Buttons from "../../components/UI/Buttons";
import Acl from "../../hoc/Acl";
import PERMISSIONS from "../../utils/AclPermissions";
import { acl_check } from "../../utils/aclUtils";
import GlobalSearch from "../../components/Layouts/NewAppLayout/GlobalSearch/GlobalSearch";
import { useNavigate } from 'react-router-dom';

const DashboardContainer = (props) => {
  const navigate = useNavigate();
  const [dashboardData, setDashBoardData] = useState({});
  const [companyOptions, setCompanyOption] = useState([
    { label: "All Company", value: "" },
  ]);
  const [clinicOptions, setClinicOptions] = useState([]);
  const hasInvoicePermission = acl_check(
    props.profile.permissions,
    PERMISSIONS.INVOICE.LIST
  );
  const hasVisitPermission = acl_check(
    props.profile.permissions,
    PERMISSIONS.VISITS.LIST
  );
  console.log("hasInvoicePermission", hasInvoicePermission);
  const resultClass = hasInvoicePermission
    ? "col-md-6 col-6 py-2"
    : "col-md-4 col-12 py-2";
  
  const [isLoading, setLoading] = useState(false);
  const [filter, setFilter] = useState({ last_updated_by: "" });
  const [dateFilter, setDateFilter] = useState({ from_date: "" }, { to_date: "" });
  const filterDropdownRef = useRef(null);

  // Get globalFilter from props (available through withReduxState HOC)
  const globalFilter = props.globalFilter || {};

  // Extract relevant filters from globalFilter using useMemo for performance
  // Dashboard can use filters from 'Visits', 'Appointments', or other related modules
  const relevantGlobalFilters = useMemo(() => {
    const relevantKeys = ["Visits", "Appointments", "Dashboard"]; // Include Appointments filter
    let mergedFilters = {};
    relevantKeys.forEach((key) => {
      if (globalFilter[key] && typeof globalFilter[key] === "object") {
        mergedFilters = { ...mergedFilters, ...globalFilter[key] };
      }
    });
    return mergedFilters;
  }, [globalFilter]);

  const prevGlobalFiltersRef = useRef(JSON.stringify(relevantGlobalFilters));

  useEffect(() => {
    fetchDashBoard();
    fetchClinic();
  }, []);

  // Watch for globalFilter changes and refetch dashboard data
  // This includes filters from Appointments, Visits, and Dashboard pages
  useEffect(() => {
    const currentFiltersStr = JSON.stringify(relevantGlobalFilters);
    const prevFiltersStr = prevGlobalFiltersRef.current;

    console.log('GlobalFilter changed - prev:', prevFiltersStr, 'current:', currentFiltersStr);
    console.log('relevantGlobalFilters:', relevantGlobalFilters);
    console.log('globalFilter from props:', globalFilter);
    console.log('Appointments filter:', globalFilter?.Appointments);

    // Skip refetch on initial mount (when prevFiltersStr matches current)
    if (prevFiltersStr === currentFiltersStr) {
      console.log('Skipping refetch - filters unchanged');
      return;
    }

    // Refetch when globalFilter changes (including when filters are cleared)
    console.log('Refetching dashboard with filters:', relevantGlobalFilters);
    fetchDashBoard();
    prevGlobalFiltersRef.current = currentFiltersStr;
  }, [relevantGlobalFilters, globalFilter]);

  useEffect(() => {
    fetchCompany();
  }, [filter.clinic_id]);

  const fetchDashBoard = async (param = filter, isRefresh = false) => {
    setLoading(true);
    let payload = {};
    if (isRefresh) {
       payload = {
        ...param,
        from_date: "",
        to_date: "",
      };
    } else {
       payload = {
        ...param,
        from_date: dateFilter.from_date,
        to_date: dateFilter.to_date,
      };
    }

    // Merge globalFilter with payload
    if (relevantGlobalFilters && Object.keys(relevantGlobalFilters).length > 0) {
      // Merge globalFilter, giving priority to local filter values
      // This allows global search filters to be applied to dashboard
      payload = {
        ...relevantGlobalFilters,
        ...payload,
      };
    }

    // Extract employee_id from globalFilter if present (from patient selection in GlobalSearch)
    // employee_id can come from Appointments filter when patient is selected
    // Check each filter key and use the first non-empty employee_id found
    const employeeIdFromFilter = 
      globalFilter?.Appointments?.employee_id || 
      globalFilter?.Visits?.employee_id || 
      globalFilter?.Dashboard?.employee_id;
    
    if (employeeIdFromFilter) {
      payload.employee_id = employeeIdFromFilter;
    } else if (employeeIdFromFilter === '') {
      // If employee_id is explicitly set to empty string, remove it from payload
      delete payload.employee_id;
    }

    if (payload.clinic_id === "") {
      payload.company_id = "";
    }
    
    console.log('fetchDashBoard payload:', payload);
    console.log('employee_id in payload:', payload.employee_id);
    const response = await VisitsService.getDashBoard(payload);
    console.log('fetchDashBoard response:', response);
    setDashBoardData(response);
    setLoading(false);
  };
  
  const setFilterDataEmpty = () => {
    setDateFilter({ from_date: "", to_date: "" });
  const updatedFilter = {
    ...filter,
      last_updated_by: "",
      clinic_id: "",
      company_id: "",
  };
    fetchDashBoard(updatedFilter, true);
  //fetchClinic();
  setCompanyOption([{ label: "All Company", value: "" }]);
  setFilter(updatedFilter);
  };
useEffect(() => {
    console.log("Updated dateFilter:", dateFilter);
}, [dateFilter]);
  const fetchCompany = async () => {
    let clinic_id = filter?.clinic_id;
    if (!clinic_id) return false;
    const response =
      await DropDownService.getAssignCompanyOptionsForSelfRegister(clinic_id);
    let companiesOptions = [{ label: "All Company", value: "" }];
    response.forEach((company) => {
      companiesOptions.push({
        label: company.name,
        value: company.company_uuid,
      });
    });
    setCompanyOption(companiesOptions);
  };
  const fetchClinic = async () => {
    let opt = [{ label: "All Clinic", value: "" }];
    let clinicResponse = await DropDownService.getClinicList(null);
    if (clinicResponse) {
      clinicResponse?.forEach((itm, ind) => {
        opt.push({ label: itm.name, value: itm.clinic_id });
      });
    }
    setClinicOptions(opt);
  };
  const filterChangeHandler = (val, name) => {
    const updatedFilter = { ...filter };
    if (val == "" && name == "clinic_id") {
      setCompanyOption([{ label: "All Company", value: "" }]);
    }
    if (name == "clinic_id" && val) {
      updatedFilter["company_id"] = "";
    }
    if (name == "last_updated_by") {
      setDateFilter({});
      closeDateFilterdropdown();
    }
    updatedFilter[name] = val;

    fetchDashBoard(updatedFilter);
    setFilter(updatedFilter);
  };
  const applyDateFilter = () => {
    const updatedFilter = {
      ...filter,
      last_updated_by: "",
      from_date: dateFilter.from_date,
      to_date: dateFilter.to_date,
  };
  fetchDashBoard(updatedFilter);
    setFilter({ ...filter, ["last_updated_by"]: "" });
  closeDateFilterdropdown();
  };
  const closeDateFilterdropdown = () => {
    if (filterDropdownRef.current) {
      filterDropdownRef.current.classList.toggle("show");
    }
  };
  const getColumnClass = () => {
    if (!hasInvoicePermission && !hasVisitPermission) {
      return "col-lg-12";
    }
    if (!hasInvoicePermission && hasVisitPermission) {
      return "col-lg-8";
    }
    return "col-lg-6";
};

  // GlobalSearch filter paths
  const globalSearchFilter = [
    "/visits",
    "/appointments",
    "/white-board",
    "/labs",
    "/result/vaccine",
    "/result/physical-drug-screens",
    "/employee",
    "/dashboard",
  ];

  // Get pathname using useLocation hook
  const location = useLocation();
  const { pathname } = location;
  const { profile } = props;

  return (
    <>
      <div className=" h-100">
        <div className="sh_cardBox border-0">
          <div
            className="sh_cardHeader border-0 py-1"
            style={{ position: "relative" }}
          >
            {/* Three-column layout: Left (Title), Center (GlobalSearch), Right (Filters) */}
            <div className="d-flex justify-content-between align-items-center w-100 flex-wrap">
              
              {/* LEFT SIDE: Title */}
              <div className="d-flex align-items-center mb-2 mb-md-0">
                <h2 className="h2-strong mb-0">Dashboard</h2>
              </div>
              <a
                    className="btn btn-primary mx-1"
                    onClick={() => navigate("/appointments")}
                  >
                 <span>
                      <Buttons className="pr-1" iconType="NewAddVisitIcon" />
                  New Appointment
                  </span>
                </a>

              {/* CENTER: Global Search */}
              <div className="d-flex justify-content-center align-items-center mb-2 mb-md-0" style={{ flex: 1 }}>
                {profile &&
                  profile.is_multiple_organization === false &&
                  profile.employee_login === false &&
                  globalSearchFilter.some((path) =>
                    pathname.startsWith(path)
                  ) && (
                    <GlobalSearch
                      activeMenu={"Appointments"}
                      pathname={pathname}
                    />
                  )}
              </div>

              {/* RIGHT SIDE: Filters */}
              <div className="d-flex justify-content-end align-items-center flex-wrap">
             <Acl acl={PERMISSIONS.CLINIC.LIST}>
              <div class="form-group dash_btn mx-1 mb-1 mx-1">
                <FormInputs
                  type="SelectList"
                  options={clinicOptions}
                  changeHandler={(value, e) =>
                        filterChangeHandler(value, "clinic_id", e)
                  }
                  value={filter?.clinic_id}
                      name={"clinic_id"}
                />
              </div>
              <div class="form-group dash_btn mx-1 mb-1">
                <FormInputs
                  type="SelectList"
                  options={companyOptions}
                  changeHandler={(value, e) =>
                        filterChangeHandler(value, "company_id", e)
                  }
                  value={filter?.company_id}
                      name={"company_id"}
                />
              </div>
              </Acl>
              <div className="form-group  mx-1 mb-0 mt-0">
                  <a
                    className="btn btn-primary my-1 dropdown dropdown-toggle"
                    id="statusbtn"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                  Time Range
                </a>
                  <div
                    class="dropdown-menu shadow  "
                    id="dash_timepickdtn"
                    aria-labelledby="statusbtn"
                    data-bs-popper="static"
                    onClick={(e) => e.stopPropagation()}
                    ref={filterDropdownRef}
                  >
                  <div class=" d-flex justify-content-between px-0 py-0" href="">
                      <div className="sh_cardBox mb-0 rounded-0">
                      <div className="sh_cardHeader border-0">
                        <h6 className="text-md font-weight-bold mb-0">
                          Absolute time range
                        </h6>
                      </div>
                      <div className="sh_cardBody py-0 px-0">
                          <div className="dash_timepicker p-2">
                          <div class="form-group ">
                              <label class="mb-0 text-sm opacity-75 text-truncate">
                                From
                              </label>
                              <div class="">
                              <FormInputs
                              type="Date"
                                  changeHandler={(value, e) => {
                                    setDateFilter({
                                      ...dateFilter,
                                      ["from_date"]: value,
                                    });
                                  }}
                              value={dateFilter?.from_date}
                              />
                            </div>
                          </div>
                          <div class="form-group ">
                              <label class="mb-0 text-sm opacity-75 text-truncate">
                                To
                              </label>
                              <div class="">
                            <FormInputs
                              type="Date"
                                  changeHandler={(value, e) => {
                                    setDateFilter({
                                      ...dateFilter,
                                      ["to_date"]: value,
                                    });
                                  }}
                              value={dateFilter?.to_date}
                              />
                            </div>
                          </div>
                          <div className="d-flex justify-content-center">
                              <a
                                className="btn btn-primary"
                                onClick={() => applyDateFilter()}
                              >
                                {" "}
                                Apply
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="sh_cardBox mb-0 rounded-0">
                      <div className="sh_cardHeader border-0">
                        <h6 className="text-md font-weight-bold mb-0">
                          Search Quick Ranges
                        </h6>
                      </div>
                      <div className="sh_cardBody py-0 px-0">
                        <div className="form-group dash_timepicker p-2">
                          <FormInputs
                            type="SelectSearchList"
                            className="form-control form-control-solid"
                            options={getLastUpdatedByOption()}
                            changeHandler={(value, e) =>
                                filterChangeHandler(value, "last_updated_by", e)
                            }
                            value={filter?.last_updated_by}
                          />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a
                    className="btn btn-primary mx-1"
                    onClick={() => setFilterDataEmpty()}
                  >
                 <span>
                      <Buttons className="pr-1" iconType="Refresh" />
                  Refresh
                  </span>
                </a>
            </div>
              </div>
            </div>
          </div>
          
          {/* Removed the old GlobalSearch block that was here */}

          <div className="sh_cardBody py-0">
            <div className="row">
              <Acl acl={PERMISSIONS.INVOICE.LIST}>
              <div className="col-12 col-lg-3 pt-2 pr-0">
                  <Invoice data={dashboardData} filter={filter} />
                  </div>
              </Acl>
              <div className={`${getColumnClass()} col-12`}>
                <div className="sh_cardBox sh_dash_invoiceht border-0 mb-0">
                  <div
                    className="sh_cardBody px-3 py-0"
                    style={{ position: "relative" }}
                  >
                    <div className="row">
                    <div className={resultClass}>
                      <Physical
                        data={dashboardData}
                        filter={filter}
                        isLoading={isLoading}
                      />
                      </div>
                      <div className={resultClass}>
                        <DrugScreen
                          data={dashboardData}
                          filter={filter}
                          isLoading={isLoading}
                        />
                      </div>
                      <div className={resultClass}>
                        <Lab
                          data={dashboardData}
                          filter={filter}
                          isLoading={isLoading}
                        />
                      </div>
                      <div className={resultClass}>
                        <Vaccines
                          data={dashboardData}
                          filter={filter}
                          isLoading={isLoading}
                        />
                      </div>

                      <div className={resultClass}>
                        <MissingClaim
                          data={dashboardData}
                          filter={filter}
                          isLoading={isLoading}
                        />
                      </div>
                      <div className={resultClass}>
                        <WorkRestrictions
                          data={dashboardData}
                          filter={filter}
                          isLoading={isLoading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Acl acl={PERMISSIONS.VISITS.LIST}>
                <div
                  className={` ${
                    hasInvoicePermission ? "col-lg-3" : "col-lg-4"
                  } col-12 pt-2 pl-0`}
                >
                  <ComplianceMonitor />
              </div>
              </Acl>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  function getLastUpdatedByOption() {
    return [
      { label: "Last 5 Minutes", value: "last_5_minutes" },
      { label: "Last 10 Minutes", value: "last_10_minutes" },
      { label: "Last 15 Minutes", value: "last_15_minutes" },
      { label: "Last 30 Minutes", value: "last_30_minutes" },
      { label: "Last 1 Hour", value: "last_1_hour" },
      { label: "Last 3 Hours", value: "last_2_hours" },
      { label: "Last 6 Hours", value: "last_6_hours" },
      { label: "Last 12 Hours", value: "last_12_hours" },
      { label: "Last 24 Hours", value: "last_24_hours" },
      { label: "Last 2 Days", value: "last_2_days" },
      { label: "Last 7 Days", value: "last_7_days" },
      { label: "Last 30 Days", value: "last_30_days" },
      { label: "Last 90 Days", value: "last_90_days" },
      { label: "Last 6 Months", value: "last_6_months" },
      { label: "Last 1 Year", value: "last_1_year" },
      { label: "Last 2 Years", value: "last_2_years" },
      { label: "Last 5 Years", value: "last_5_years" },
      { label: "Today", value: "today" },
      { label: "Yesterday", value: "yesterday" },
      { label: "Day Before Yesterday", value: "day_before_yesterday" },
      { label: "This day last week", value: "this_day_last_week" },
      { label: "Previous Week", value: "previous_week" },
      { label: "Previous Month", value: "previous_month" },
      { label: "This Week ", value: "this_week" },
      { label: "This Month ", value: "this_month" },
      { label: "This Year", value: "this_year" },
      { label: "ALL", value: "" },
    ];
  }
};

export default withReduxState(DashboardContainer);